'use client';

import React from 'react';
import { QueryClientProvider as TanstackQueryClientProvider } from '@tanstack/react-query';
import type { QueryClientProviderProperties } from './types';
import { QUERY_CLIENT } from './consts';

function QueryClientProvider({ children }: QueryClientProviderProperties) {
  return (
    <TanstackQueryClientProvider client={QUERY_CLIENT}>
      {children}
    </TanstackQueryClientProvider>
  );
}

export default React.memo(QueryClientProvider);
